<template>
    <a-drawer
      :title="'课程模板-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%">
        <div class="input-box">
            <p>课程名称：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.courseName"/>
        </div>
        <div class="input-box">
            <p>课程编号：</p>
            <a-input class="input" :disabled="actionName!='新增'" v-model="info.courseCode"/>
        </div>
        <div class="input-box">
            <p>学分：</p>
            <a-input-number class="input" :disabled="actionName=='查看'" v-model="info.courseCredit" />
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { plus,update } from '@/baseAPI/undergraduate/culture/courseMould'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    courseName:null,
                    courseCode:null,
                    courseCredit:null,
                },
            }
        },
        mounted () {
        },
        methods:{
            showDrawer(name,res){
                if(name!='新增'){
                    this.info=res;
                }
                this.actionName=name;
                this.visible=true;
            },
            onClose() {
                this.info={
                    courseName:null,
                    courseCode:null,
                    courseCredit:null,
                };
                this.visible = false;
                this.$parent.fetch();
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus']
                console.log(this.info)
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        plus(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增课程模板成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改课程模板成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
